import React, { ReactElement } from 'react'
import { LinkProps } from 'next/dist/client/link'
import noopWrapper from 'lib/noop-wrapper'
import Link from 'next/link'

const LightLink = (props: React.PropsWithChildren<LinkProps>) => {
  const { children, as, href, ...rest } = props
  const isSSR = typeof window === 'undefined'

  const child = isSSR
    ? React.cloneElement(React.Children.only(children) as any, {
        href: as || href,
      })
    : children

  return (
    isSSR
      ? noopWrapper
      : (content: React.ReactNode) => (
          <Link href={href} as={as} {...rest}>
            {content}
          </Link>
        )
  )(child) as ReactElement
}

export default LightLink
